// extracted by mini-css-extract-plugin
export default {"tcoButton":"_2VG8Xp","tcoButtonDisabled":"uFZpv2"};